import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
			<p class="mb-3">
				Человек на улице предлагает билет на экскурсию. 
				Но не всем.
			</p>
			<p class="mb-3">
				Оплата на месте прибытия. 
				Место – там, куда хочется, куда стремится душа. В пути оказывается, что у всех попутчиков – разные направления, разные цели. 
				Этих людей определили по отчаянию в душе, невидящим глазам, замкнутым устам. 
				Им не нужно окружающее их, не нужно настоящее. 
				Они хотят уйти; и им дают уйти.
			</p>
			<p class="mb-3">
				Каждый приходит туда, куда хочет: в глухой лес, в огромную, закрытую от мира библиотеку, на остров посреди моря; а то и на карнавал в Рио, 
				где можно затеряться среди бушующей толпы надёжнее, чем на необитаемом острове или в тюремной камере-одиночке. 
				А кто-то хотел уже прямо на эшафот, к гордой гибели на виду у торжествующих врагов; это было бы прекрасным завершением их начавшегося великим, 
				но постепенно угасавшего и поникавшего жизненного пути.
			</p>
			<p class="mb-3">
				Никто не покинет дилижанса; всех довезут до места, предназначенного каждому из них. 
				Турбюро «Заветное желание» к вашим услугам, экскурсии каждый день в 12, 14 и 15 часов с главной улицы города. 
				Добро пожаловать!
			</p>
		</div>
    `
  )
}

const itemName = {
  rus: `Дальняя дорога`
}

const itemDate = {
	rus: "6 сентября 2024 г."
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
		itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;

